import { DatePipe } from '@angular/common';
import { AfterContentInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { NotificationService } from 'src/app/core/notification.service';
import { PicketService } from 'src/app/core/picket.service';
import { ApiResponse } from 'src/app/shared/interfaces/api-response';
import { PicketRecordDetails } from 'src/app/shared/interfaces/picket-member-details';

@Component({
  selector: 'app-manual-entry',
  templateUrl: './manual-entry.component.html',
  styleUrls: ['./manual-entry.component.css']
})
export class ManualEntryComponent implements AfterContentInit, OnInit {
  @ViewChild("searchBox", {}) searchBoxElement: ElementRef | undefined;

  sendingRecord = false;
  currentTime = new Date();
  strikeId = '';
  picketId = '';
  picketLineName = '';
  memberSearchForm = new FormGroup({
    filterMember: new FormControl<string>("", { nonNullable: true })
  })
  memberId = ''
  member: PicketRecordDetails = { MemberId: '' }
  manualRecIndex = 0
  manualRecords: PicketRecordDetails[] = []
  lastAddedEntry: PicketRecordDetails = {
    SlNo: 0,
    MemberId: '',
    Name: '',
    WalkDate: this.currentTime,
    WalkDateLocal: this.currentTime.toLocaleDateString(),
    SignIn: this.currentTime,
    SignOut: this.currentTime,
    Hours: '',
    Minutes: ''
  }
  newManualEntry: PicketRecordDetails = {
    MemberId: '',
    WalkDate: this.currentTime,
    WalkDateLocal: this.currentTime.toLocaleDateString(),
    SignInTime: this.currentTime,
    SignOutTime: this.currentTime
  }

  constructor(
    private route: ActivatedRoute,
    private picketService: PicketService,
    private notificationService: NotificationService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.strikeId = String(this.route.snapshot.paramMap.get("id"));
    this.picketId = String(this.route.snapshot.paramMap.get("picket"));
    this.picketLineName = String(this.route.snapshot.paramMap.get("name"));
  }
  ngAfterContentInit() {
    this.resetFocus()
  }

  async searchMbr() {
    const response = await this.picketService.getPicketMemberInfo(
      this.strikeId,
      this.memberSearchForm.getRawValue().filterMember
    );
    if (response.success) {
      this.searchMbrSuccess(response);
    } else {
      this.searchMbrFail(response);
    }
  }

  clearSearchMbr() {
    this.memberSearchForm.setValue({ filterMember: '' })
  }

  async searchMbrSuccess(response: ApiResponse) {
    this.member = response.body;
    this.memberId = String(this.member?.ID)
  }

  searchMbrFail(response: ApiResponse) {
    this.member = { MemberId: '' };
    if (response.statusCode == 400) {
      this.notificationService.displayError(response.body);
    }
    else {
      this.notificationService.displayError(response.errorMessage);
    }
  }

  saveRecord() {
    this.sendingRecord = true
    this.newManualEntry.StrikeInfoId = this.strikeId;
    this.newManualEntry.StrikeMemberId = this.member.ID;
    this.newManualEntry.StrikePicketlineId = this.picketId;
    this.newManualEntry.SignInMethod = "Manual Entry";
    this.newManualEntry.SignOutMethod = "Manual Entry";
    this.newManualEntry.SignInLocalTime = String(this.datePipe.transform(this.newManualEntry.SignInTime, "MM/dd/yyyy HH:mm"));
    this.newManualEntry.SignOutLocalTime = String(this.datePipe.transform(this.newManualEntry.SignOutTime, "MM/dd/yyyy HH:mm"));
    this.newManualEntry.WalkDateLocal = this.newManualEntry.WalkDate?.toLocaleDateString();

    this.newManualEntry.FirstName = this.member.FirstName;
    this.newManualEntry.LastName = this.member.LastName;
    this.newManualEntry.MemberId = this.member.MemberId;
    this.newManualEntry.MiddleName = this.member.MiddleName;

    this.newManualEntry.StrikePicketlineId = this.picketId;

    this.picketService.addManual(this.newManualEntry).then((response) => {
      if (response.success) {
        this.addedManualEntrySuccess(response)
      } else {
        this.addedManualEntryFail(response)
      }
      this.sendingRecord = false
    })
  }
  addManualEntry() {
    this.saveRecord()
    this.member = { MemberId: '' }
    this.clearSearchMbr()
    this.resetFocus()
  }

  resetFocus() {
    if (this.searchBoxElement) {
      this.searchBoxElement.nativeElement.focus()
    }
  }

  addSameMbrManualEntry() {
    this.saveRecord()
  }

  addedManualEntrySuccess(response: ApiResponse) {
    this.notificationService.displaySuccess("Sign-in recorded successfully!");
    this.lastAddedEntry.Hours = response.body.Hours
    this.lastAddedEntry.Minutes = response.body.Minutes
    this.manualRecIndex += 1;

    this.lastAddedEntry.SlNo = this.manualRecIndex
    this.lastAddedEntry.MemberId = this.newManualEntry.MemberId
    this.lastAddedEntry.Name = this.newManualEntry.FirstName + (this.newManualEntry.MiddleName ? '' : ' ' + this.newManualEntry.MiddleName) + ' ' + this.newManualEntry.LastName
    this.lastAddedEntry.WalkDate = this.newManualEntry.WalkDate
    this.lastAddedEntry.SignIn = this.newManualEntry.SignInTime
    this.lastAddedEntry.SignOut = this.newManualEntry.SignOutTime

    this.manualRecords.push(this.lastAddedEntry)
    this.lastAddedEntry = {
      SlNo: 0,
      MemberId: '',
      Name: '',
      WalkDate: this.currentTime,
      SignIn: this.currentTime,
      SignOut: this.currentTime,
      Hours: '',
      Minutes: ''
    }
    this.newManualEntry = {
      MemberId: '',
      WalkDate: this.newManualEntry.WalkDate,
      SignInTime: this.newManualEntry.SignInTime,
      SignOutTime: this.newManualEntry.SignOutTime
    }
  }

  addedManualEntryFail(response: ApiResponse) {
    this.notificationService.displayError(response.errorMessage)
  }

}
